import React from 'react';
import { useIntl } from 'react-intl';
import { ReactComponent as IconHelp } from '../../media/images/icon-help.svg';
import rentalcoverSharedMessages from '../../helpers/messages/commonMsg';
import NavItem from '../NavItem';
import { getButtonProps } from '../../helpers/button';

export const HelpButton = () => {
  const { formatMessage, locale } = useIntl();

  return (
    <NavItem
      key="help"
      name={formatMessage(rentalcoverSharedMessages.helpLinkText)}
      icon={IconHelp}
      {...getButtonProps({ link: '/help', locale })}
      data-test-id="nav-item-help"
    />
  );
};

export const ClaimsButton = () => {
  const { formatMessage, locale } = useIntl();

  return (
    <NavItem
      key="claims"
      name={formatMessage(rentalcoverSharedMessages.claimsLinkText)}
      {...getButtonProps({ link: '/claim', locale })}
      data-test-id="nav-item-claim-help-page"
    />
  );
};
